import { MapControl } from "@vis.gl/react-google-maps";
import { mapRecenterImage } from "assets";
import { DEFAULT_ZOOM_LEVEL } from "../../../constants";
import { CustomRecenterControlProps } from "type";

export const CustomRecenterControl = ({
  controlPosition,
  endLocation,
  onRecenter,
  map,
}: CustomRecenterControlProps) => {
  const handleRecenter = () => {
    if (map && endLocation) {
      map.panTo(endLocation);
      map.setZoom(DEFAULT_ZOOM_LEVEL); // Optional: set zoom level when re-centering
      if (onRecenter) {
        onRecenter();
      }
    }
  };

  return (
    <MapControl position={controlPosition}>
      <button
        onClick={handleRecenter}
        title="Re-center"
        style={{
          background: "transparent",
          border: "none",
          padding: 15,
          cursor: "pointer",
        }}
      >
        <img
          src={mapRecenterImage}
          alt="Re-center"
          style={{
            width: "var(--recenter-icon-size-wd)",
            height: "var(--recenter-icon-size-hg)",
          }}
        />
      </button>
    </MapControl>
  );
};
